import { render, staticRenderFns } from "./ConfigTrashIson.vue?vue&type=template&id=4ecd9896"
import script from "./ConfigTrashIson.vue?vue&type=script&lang=js"
export * from "./ConfigTrashIson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports